module.exports = __webpack_public_path__ + "img/banner04.9bb2991b.jpg";